// extracted by mini-css-extract-plugin
export default {"form":"profile-form_form_dBFeM","submit":"profile-form_submit_L28Z4"};